import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '../../lib/cn';

export interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: ReactNode;
  /** Effectively required wherever the user can create the missing thing. */
  action?: ReactNode;
  secondaryAction?: ReactNode;
  /** 'panel' (default): page-level block, 48px rhythm. 'inline': inside a table region. */
  size?: 'inline' | 'panel';
  className?: string;
}

export default function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  secondaryAction,
  size = 'panel',
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center px-6 text-center',
        size === 'panel' ? 'py-12' : 'py-8',
        className,
      )}
    >
      {Icon && (
        <span className="mb-4 flex size-12 items-center justify-center rounded-full bg-surface-well text-ink-faint">
          <Icon size={24} />
        </span>
      )}
      <h3 className="t-card text-green-900">{title}</h3>
      {description && <p className="t-body mt-1 max-w-md text-ink-soft">{description}</p>}
      {(action || secondaryAction) && (
        <div className="mt-4 flex items-center gap-2">
          {action}
          {secondaryAction}
        </div>
      )}
    </div>
  );
}
